module.exports = __webpack_public_path__ + "static/media/wally-logo.a1d471dd.png";